import { axiosService } from '@services'

import { API } from '../endPoints'

export default async function getPlantStatus(plantId: string) {
  if(!plantId) {
    throw new Error('Plant ID is required');
  }

  const apiPath = API.PLANT_MANAGEMENT
  return axiosService({ method: 'post', data: { path: `/status`, plant_id: plantId }, apiPath })
}
